import { Loader, LogIn } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';

import { NewPasswordField } from '@/components/form/new-password-field';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { usePasswordStrength } from '@/hooks/use-password-strength';
import {
  InviteOrganizationFormValues,
  ResetPasswordFormValues,
} from '@/services/auth/form-schemas';

interface ResetPasswordFormProps {
  form: UseFormReturn<ResetPasswordFormValues | InviteOrganizationFormValues>;
  onSubmit: () => void;
  isPending: boolean;
}

export const ResetPasswordForm = ({
  form,
  onSubmit,
  isPending,
}: ResetPasswordFormProps) => {
  const passwordStrength = usePasswordStrength(
    form.watch('password'),
    form.getValues('password'),
  );
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="space-y-4">
        <NewPasswordField
          form={form}
          name="password"
          label="Password"
          autoComplete="new-password"
          disabled={false}
          passwordStrength={passwordStrength}
        />
        <Button disabled={isPending} className="w-full" type="submit">
          {isPending ? (
            <Loader className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <LogIn className="mr-2 h-4 w-4" />
          )}
          Complete Account
        </Button>
      </form>
    </Form>
  );
};
